import { basicTrackDecorator as customTrackDecorator, trackDecoratorWithExtendedLabel } from 'services/Analytics';

/**
 * 1. CLick on Pause button
 */
export const pauseFlow_pauseClick = ({ subscription_id }: { subscription_id: string }) => {
    trackDecoratorWithExtendedLabel('pause_subscription__click', 'pause', undefined, {
        subscription_id,
        event_schema_key: 'iglu:com.welltech.unified.web/pause_subscription__click/jsonschema/1-2-0',
    });
};

/**
 * 2. Screen load for pause subscription details
 */
export const pauseFlow_pauseDetailsScreenLoad = ({ subscription_id }: { subscription_id?: string }) => {
    trackDecoratorWithExtendedLabel('pause_subscription__screen__load', undefined, undefined, {
        subscription_id,
        event_schema_key: 'iglu:com.welltech.unified.web/pause_subscription__screen__load/jsonschema/1-2-0',
    });
};

/**
 * 3. Confirm pause, "X" (close modal)
 */
export const pauseFlow_pauseResultClick = ({
    action,
    result,
    subscription_id,
}: {
    action: 'claim_offer' | 'close' | 'try_again' | 'contact_support' | 'got_it' | 'continue';
    result?: 'success' | 'fail';
    subscription_id?: string;
}) => {
    customTrackDecorator('pause_subscription_result__click', action, result, {
        subscription_id,
        event_schema_key: 'iglu:com.welltech.unified.web/pause_subscription_result__click/jsonschema/1-2-1',
    });
};

export const pauseFlow_pauseResultScreenLoad = ({
    result,
    subscription_id,
}: {
    result: 'success' | 'fail';
    subscription_id?: string;
}) => {
    trackDecoratorWithExtendedLabel(
        'pause_result__screen__load',
        undefined,
        { result },
        {
            subscription_id,
            event_schema_key: 'iglu:com.welltech.unified.web/pause_result__screen__load/jsonschema/1-2-1',
        }
    );
};
